import {
  IFilterGroup,
  IFilterGroupMap,
} from '@/components/Product/Filters/types';
import { IProductMetalType } from '@/types/product';

export const filterGroup: IFilterGroupMap = {
  metal: {
    key: 'metal',
    items: [IProductMetalType.gold, IProductMetalType.whiteGold],
  },
};

export const filterGroups: IFilterGroup[] = Object.values(filterGroup);
